import {
  isCurrentView,
  hideAlertEventListener,
} from "../../../shared/utils/view-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".sbsa-portal.setup")) {
    return;
  }

  $(".completed").on("click", (e) => {
    e.stopImmediatePropagation();
    e.preventDefault();
  });

  hideAlertEventListener(".close-warning", "feedback-alert");
});
